import { ErrorEmptyState } from '@carbon/ibm-products';
import { defineMessages, useIntl } from 'react-intl';

type Props = {
    actionTitle?: string;
    onClick?: () => void;
    className?: string;
}

const ErrorActionState = ({
    actionTitle,
    onClick,
    className,
}: Props) => {
    const intl = useIntl();

    return (
        <ErrorEmptyState
            className={className}
            action={onClick ? {
                onClick,
                text: actionTitle ?? intl.formatMessage(messages.downloadAction),
            } : undefined}
            headingAs="h3"
            illustrationDescription={intl.formatMessage(messages.exclamationMark)}
            subtitle={intl.formatMessage(messages.subtitle)}
            title={intl.formatMessage(messages.title)}
        />
    );
};

const messages = defineMessages({
    title: {
        id: 'src.Components.Common.Notifications.ErrorState.ErrorActionState.title',
        defaultMessage: 'Błąd przy pobieraniu danych',
    },
    subtitle: {
        id: 'src.Components.Common.Notifications.ErrorState.ErrorActionState.subtitle',
        defaultMessage: 'Coś poszło nie tak. Spróbuj ponownie.',
    },
    downloadAction: {
        id: 'src.Components.Common.Notifications.ErrorState.ErrorActionState.downloadAction',
        defaultMessage: 'Pobierz ponownie',
    },
    exclamationMark: {
        id: 'src.Components.Common.Notifications.ErrorState.ErrorActionState.exclamationMark',
        defaultMessage: 'Wykrzyknik wskazujący na błąd',
    },
});

export default ErrorActionState;
